/* tslint:disable */
/* eslint-disable */

/**
 * 0 = QuoteReminder
 * 
 * 1 = QuoteNegotiationAutoReminder
 * 
 * 2 = HolidayToApprove
 * 
 * 3 = MachineCalibrationDue
 * 
 * 4 = MachineCalibrationOverdue
 * 
 * 5 = PressureMachineCalibrationDue
 * 
 * 6 = PressureMachineCalibrationOverdue
 * 
 * 7 = ElectricalEquipmentCalibrationDue
 * 
 * 8 = ElectricalEquipmentCalibrationOverdue
 * 
 * 9 = PurchaseOrderReview
 * 
 * 10 = SalesQuoteAdded
 * 
 * 11 = AssetReturnedToCheck
 * 
 * 12 = SupplierReminder
 * 
 * 13 = CycleCountDue48
 * 
 * 14 = CycleCountDue24
 * 
 * 15 = CycleCountDueToday
 * 
 * 16 = CycleCountOverdue
 * 
 * 17 = SalesHandover
 */
export enum NotificationAction {
  QuoteReminder = 0,
  QuoteNegotiationAutoReminder = 1,
  HolidayToApprove = 2,
  MachineCalibrationDue = 3,
  MachineCalibrationOverdue = 4,
  PressureMachineCalibrationDue = 5,
  PressureMachineCalibrationOverdue = 6,
  ElectricalEquipmentCalibrationDue = 7,
  ElectricalEquipmentCalibrationOverdue = 8,
  PurchaseOrderReview = 9,
  SalesQuoteAdded = 10,
  AssetReturnedToCheck = 11,
  SupplierReminder = 12,
  CycleCountDue48 = 13,
  CycleCountDue24 = 14,
  CycleCountDueToday = 15,
  CycleCountOverdue = 16,
  SalesHandover = 17
}
